import {
  DisclosureSlot,
  FeatureIconGrid,
  HowItWorksSteps,
  ImagePlaceholder,
  MarketingPageLayout,
  MarketingSection,
  PartnerLogoStrip,
} from '@nwwp/ui-shadcn'
import { CAPABILITIES, STEPS } from './data'
import { ScheduleCallCTA } from '../../controls/ScheduleCallCTA'

function CtaBlock({ segmentElement }: { segmentElement: string }) {
  return (
    <div className="flex flex-col items-center">
      <ScheduleCallCTA segmentElement={segmentElement} className="w-full max-w-md text-blue-darkest">
        Schedule a free call today
      </ScheduleCallCTA>
    </div>
  )
}

/**
 * Default composition exemplar for custom marketing landing pages.
 * New pages copy this pattern — kit blocks + ScheduleCallCTA — not freehand JSX.
 */
export function ExemplarContent() {
  return (
    <div className="bg-background">
      <section className="px-4 pt-6 pb-10 bg-dark-gradient tablet:rounded-b-2xl tablet:px-0 tablet:pt-12 tablet:pb-20">
        <div className="mx-auto flex w-full max-w-xl flex-col gap-6 tablet:max-w-3xl tablet:flex-row tablet:items-center tablet:gap-12">
          <div className="flex flex-col gap-6">
            <h1 className="text-title-2xl text-white">A financial partner for the decisions that matter most</h1>
            <p className="text-body text-white">
              Fee-only advisors who help you navigate taxes, investments, retirement, and everything in between.
            </p>
            <CtaBlock segmentElement="LP Exemplar Hero CTA" />
          </div>
          <div className="w-full shrink-0 tablet:max-w-105">
            <ImagePlaceholder label="Hero image — upload to CDN" ratio={85 / 57} />
          </div>
        </div>
      </section>

      <MarketingPageLayout className="max-w-4xl gap-16 py-12">
        <HowItWorksSteps steps={STEPS} />

        <PartnerLogoStrip firms={[{ name: 'Partner A' }, { name: 'Partner B' }, { name: 'Partner C' }]} />

        <FeatureIconGrid title="Your advisor can help you with:" variant="rows" items={CAPABILITIES} />

        <MarketingSection title="Start with a free call">
          <CtaBlock segmentElement="LP Exemplar Footer CTA" />
        </MarketingSection>

        <DisclosureSlot />
      </MarketingPageLayout>
    </div>
  )
}
